module.exports = __webpack_public_path__ + "f780a694f4da562b1c707678797abdfe.fbx";